import type { PackageStateType } from './types';

export const extrasDTO = (data: unknown): PackageStateType['extras'] => {
  if (data && Array.isArray(data)) {
    return data.map((extraItem) => ({
      id:
        'id' in extraItem && typeof extraItem.id === 'number'
          ? extraItem.id
          : null,
      name:
        'name' in extraItem && typeof extraItem.name === 'string'
          ? extraItem.name
          : null,
      price:
        'price' in extraItem && typeof extraItem.price === 'number'
          ? extraItem.price
          : null,
      hashsum:
        'hashsum' in extraItem && typeof extraItem.hashsum === 'string'
          ? extraItem.hashsum
          : null,
      scope:
        'scope' in extraItem && typeof extraItem.scope === 'string'
          ? extraItem.scope
          : null,
      icon:
        'icon' in extraItem && typeof extraItem.icon === 'string'
          ? extraItem.icon
          : null,
      description:
        'description' in extraItem && typeof extraItem.description === 'string'
          ? extraItem.description
          : null,
      tooltip:
        'tooltip' in extraItem && typeof extraItem.tooltip === 'string'
          ? extraItem.tooltip
          : null,
      mandatory:
        'mandatory' in extraItem && typeof extraItem.mandatory === 'boolean'
          ? extraItem.mandatory
          : null,
      recommend:
        'recommend' in extraItem && typeof extraItem.recommend === 'boolean'
          ? extraItem.recommend
          : null,
      image:
        'image' in extraItem && typeof extraItem.image === 'string'
          ? extraItem.image
          : null,
      isMobile:
        'isMobile' in extraItem && typeof extraItem.isMobile === 'boolean'
          ? extraItem.isMobile
          : null,
      isCompact:
        'isCompact' in extraItem && typeof extraItem.isCompact === 'boolean'
          ? extraItem.isCompact
          : null,
      selected:
        'selected' in extraItem && typeof extraItem.selected === 'boolean'
          ? extraItem.selected
          : null,
      code_name:
        'code_name' in extraItem && typeof extraItem.code_name === 'string'
          ? extraItem.code_name
          : '',
    }));
  }

  return [];
};
